import { useState } from 'react';
import { encryptData, decryptData } from '../services/encryptDecrypt';

import Cookies from 'universal-cookie';

const useCookie = (key, options = {}) => {
  const cookies = new Cookies();
  const [item, setItemValue] = useState(() => {
    if (cookies.get(key)) {
      let cookie = cookies.get(key);
      return decryptData(cookie);
    }
    return null;
  });

  const setCookie = (key, value, options) => {   
    setItemValue(value);
    cookies.set(key, encryptData(value), options);
    //console.log('setting '+ key + ' cookie with the value: ' + value);
  };

  const removeCookie = (key) => {
    cookies.remove(key);
  };

  return [item, setCookie, removeCookie];
};

export default useCookie;